import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { bindActionCreators } from 'redux';
import * as registerActions from 'modules/register';

import * as validFunc from 'libs/validation';
import * as registerLib from 'libs/registerLib';
import * as commonVar from 'libs/commonVar';

import { Register } from 'components';

class CtRegister extends Component {
  constructor(props) {
    super(props);

    this.registerParam = {
      userEmail: '',
      userPasswd: '',
      repeatPasswd: '',
      userName: '',
      userPhone: '',
      serviceName: '',
      agree: false
    };
    this.state = { isLoading: false };
    this.validate = this.validate.bind(this);
  }

  setError = (fieldName, error) => {
    const update = {};

    update[fieldName + 'Error'] = error;
    this.setState(update);
  };

  keyPress = e => {
    if (e.key === 'Enter') {
      this.signUp();
    }
  };

  checkUserEmail = target => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    let checked = false;

    if (target.value.length < 1) {
      this.setError(
        'userEmail',
        defineMessages(formatMessage({ id: 'CtRegister_1', defaultMessage: '이메일을 입력해주세요.' }))
      );
    } else if (validFunc.email(target.value)) {
      this.setError('userEmail', validFunc.email(target.value));
    } else {
      this.setError('userEmail', true);
      checked = true;
    }

    // GS 범위 지정
    if (!!validFunc.range320(target.value)) {
      this.setError('userEmail', validFunc.range320(target.value));
      checked = false;
    }

    return checked;
  };

  // 비밀번호
  checkUserPasswd = async target => {
    try {
      // 국제화 처리
      const { formatMessage } = this.props.intl;
      let checked = false;

      if (target.value.length < 1) {
        this.setError('userPasswd', [
          defineMessages(formatMessage({ id: 'CtRegister_3', defaultMessage: '비밀번호를 입력해 주세요.' }))
        ]);
      } else {
        const param = {
          userEmailId: this.registerParam.userEmail.split('@')[0],
          userPasswd: target.value
        };
        const respObj = await registerLib.checkPasswordAPI(param);
        if (respObj && respObj.status && respObj.status === 200) {
          // 비밀번호 규칙 실패
          if (
            respObj.data &&
            Array.isArray(respObj.data.list) &&
            respObj.data.list[0].error &&
            !!respObj.data.list[0].error.bit
          ) {
            const { error } = respObj.data.list[0];
            this.setError('userPasswd', validFunc.passwordVlidation(error));
          } else {
            // GS인증용
            if (validFunc.gsPassword(target.value)) {
              this.setError('userPasswd', ['입력 허용 범위: [ 8~15자 ]']);
            } else {
              this.setError('userPasswd', true);
              checked = true;
            }
          }
        } else {
          // 통신 에러
          console.log('통신 에러');
        }
      }

      return checked;
    } catch (e) {
      console.log(e);
    }
  };

  // 비밀번호 재확인
  checkrepeatPasswd = (target, value) => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    let checked = false;

    if (target.value.length < 1) {
      this.setError(
        'repeatPasswd',
        defineMessages(formatMessage({ id: 'CtRegister_5', defaultMessage: '비밀번호를 다시 입력해 주세요.' }))
      );
    } else if (value === target.value) {
      this.setError('repeatPasswd', true);
      checked = true;
    } else {
      this.setError(
        'repeatPasswd',
        defineMessages(formatMessage({ id: 'CtRegister_6', defaultMessage: '비밀번호가 일치하지 않습니다.' }))
      );
    }

    return checked;
  };

  // 이름
  checkUserName = target => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    let checked = false;

    if (target.value.length < 1) {
      this.setError(
        'userName',
        defineMessages(formatMessage({ id: 'CtRegister_7', defaultMessage: '사용자 이름을 입력해 주세요.' }))
      );
    } else if (validFunc.userName(target.value)) {
      this.setError('userName', validFunc.userName(target.value));
    } else {
      this.setError('userName', true);
      checked = true;
    }

    // GS 범위 지정
    if (!!validFunc.range50(target.value)) {
      this.setError('userName', validFunc.range50(target.value));
      checked = false;
    }

    return checked;
  };

  // 연락처
  checkUserPhone = target => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    let checked = false;

    if (target.value.length < 1) {
      this.setError('userPhone', false);
    } else if (validFunc.userPhone(target.value)) {
      this.setError('userPhone', validFunc.userPhone(target.value));
    } else {
      this.setError('userPhone', true);
      checked = true;
    }

    // // GS 범위 지정
    // if (!!validFunc.range320(target.value)) {
    //   this.setError('userPhone', validFunc.range320(target.value));
    //   checked = false;
    // }

    return checked;
  };

  checkServiceName = target => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    let checked = false;
    // language=JSRegexp
    const re = /^[가-힣a-zA-Z1-9]+$/;

    if (target.value.length < 1) {
      this.setError(
        'serviceName',
        defineMessages(formatMessage({ id: 'CtRegister_9', defaultMessage: '서비스명을 입력해 주세요.' }))
      );
    } else if (!re.test(target.value)) {
      this.setError('serviceName', validFunc.serviceName(target.value));
    } else {
      this.setError('serviceName', true);
      checked = true;
    }

    // GS 범위 지정
    if (!!validFunc.range50(target.value)) {
      this.setError('serviceName', validFunc.range50(target.value));
      checked = false;
    }

    return checked;
  };

  validate = async (e, data) => {
    try {
      // 국제화 처리
      const { formatMessage } = this.props.intl;
      let checked = false;
      const target = e.target;
      if (target.name === 'userEmail') {
        checked = this.checkUserEmail(target);
      } else if (target.name === 'userPasswd') {
        checked = await this.checkUserPasswd(target);
      } else if (target.name === 'repeatPasswd') {
        checked = this.checkrepeatPasswd(target, this.registerParam.userPasswd);
      } else if (target.name === 'userName') {
        checked = this.checkUserName(target);
      } else if (target.name === 'userPhone') {
        checked = this.checkUserPhone(target);
      } else if (target.name === 'serviceName') {
        checked = this.checkServiceName(target);
      } else if (target.name === 'agree') {
        if (target.checked) {
          this.setError('agree', true);
          checked = true;
        } else {
          this.setError(
            'agree',
            defineMessages(formatMessage({ id: 'CtRegister_10', defaultMessage: 'MudFix 이용약관에 동의해 주세요.' }))
          );
        }
      }

      return checked;
    } catch (e) {
      console.log(e);
    }
  };

  userChange = e => {
    if (e.target.type === 'checkbox') {
      this.validate({
        target: { name: 'agree', checked: e.target.checked }
      });
    }
    this.registerParam[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
  };

  signUp = async () => {
    this.setState({ isLoading: true });
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    let result;
    const params = this.registerParam;
    const { RegisterActions } = this.props;

    try {
      let check = false;
      let pwCheck = false;
      check = await this.validate({
        target: { name: 'userEmail', value: params.userEmail || '' }
      });
      check = await this.validate({
        target: {
          name: 'userPasswd',
          value: params.userPasswd || ''
        }
      });
      pwCheck = await this.validate({
        target: {
          name: 'repeatPasswd',
          value: params.repeatPasswd || ''
        }
      });
      check = await this.validate({
        target: { name: 'userName', value: params.userName || '' }
      });
      check = await this.validate({
        target: { name: 'userPhone', value: params.userPhone || '' }
      });
      check = await this.validate({
        target: {
          name: 'serviceName',
          value: params.serviceName || ''
        }
      });
      check = await this.validate({
        target: { name: 'agree', checked: params.agree || '' }
      });

      if (check && pwCheck) {
        result = await RegisterActions.postRegister({
          serviceName: this.registerParam.serviceName,
          userEmail: this.registerParam.userEmail,
          userName: this.registerParam.userName,
          userPasswd: this.registerParam.userPasswd,
          userPhone: this.registerParam.userPhone
        });
        if (!!result.data.list && result.data.list['result'] === 'Success') {
          // 가입완료 페이지 이동
          this.props.history.push({ pathname: '/register/complete' });
        } else if (!!result.data.error && result.data.error[0].errInfo === 'Duplicate User Exist') {
          // 중복 유저 처리
          this.setError(
            'userEmail',
            defineMessages(formatMessage({ id: 'CtRegister_11', defaultMessage: '중복된 이메일이 있습니다.' }))
          );

          // 일본 버전의 경우 특정 서비스 도메인 제한
        } else if (
          commonVar.isJapan === 1 &&
          !!result.data.error &&
          result.data.error[0].errInfo === 'Restricted domain'
        ) {
          this.setError('userEmail', 'フリーメールはご利用できません。');
        } else {
          // 이외 에러는 가입페이지
          this.props.history.push({ pathname: '/register' });
        }
        this.setState({ isLoading: false });
      } else {
        console.log('validation error.');
        this.setState({ isLoading: false });
      }
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { register } = this.props;
    const registerData = register.toJS();

    // noinspection JSUnresolvedVariable
    return (
      <Register
        isLoading={this.state.isLoading}
        userEmailError={this.state.userEmailError}
        userPasswdError={this.state.userPasswdError}
        repeatPasswdError={this.state.repeatPasswdError}
        userNameError={this.state.userNameError}
        userPhoneError={this.state.userPhoneError}
        serviceNameError={this.state.serviceNameError}
        agreeError={this.state.agreeError}
        registerData={registerData}
        userChange={this.userChange}
        validate={this.validate}
        keyPress={this.keyPress}
        signUp={this.signUp}
      />
    );
  }
}

CtRegister.propTypes = {};
CtRegister.defaultProps = {};

const mapStateToProps = state => {
  return {
    register: state.register.get('register')
  };
};

const mapDispatchToProps = dispatch => ({
  RegisterActions: bindActionCreators(registerActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtRegister));



// WEBPACK FOOTER //
// ./src/script/containers/register/CtRegister.js